import { useEffect, useState } from 'react';
import { theme } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { useNavigate } from 'react-router-dom';
import AuthService from 'services/auth';
import { useAuth } from 'contexts/auth';
import { useApp } from 'contexts/app';

const authService = new AuthService();

const useLogin = () => {
  const { token } = theme.useToken();
  const [form] = useForm();
  const { showLoading } = useApp();
  const [loginError, setLoginError] = useState(null);
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    localStorage.removeItem('workSpace');
  }, []);

  const handleContinue = () => {
    form.submit();
  };

  const onFinish = async () => {
    setLoginError(null);
    showLoading(true);
    const data = { ...form.getFieldsValue() };

    const user = await authService.userLogin(data);
    showLoading(false);

    if (user) {
      login(user);
    } else {
      setLoginError({ message: 'Incorrect username or password' });
    }
  };

  const goResetPassword = () => {
    navigate('/reset-password');
  };

  const goRegister = () => {
    navigate('/register');
  };

  return {
    token,
    form,
    loginError,
    handleContinue,
    onFinish,
    goResetPassword,
    goRegister,
  };
};

export default useLogin;
